import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row q-mt-md" }
const _hoisted_2 = { class: "col-md-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row q-mt-sm" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col offset-md-4" }
const _hoisted_11 = { class: "row fit items-top" }
const _hoisted_12 = { class: "q-pr-xl q-mr-xl" }
const _hoisted_13 = { class: "row q-pb-lg" }
const _hoisted_14 = {
  class: "col-12",
  style: {"padding-right":"100px"}
}
const _hoisted_15 = { class: "row fit no-wrap justify-between items-end content-start" }
const _hoisted_16 = {
  class: "col-grow",
  style: {"overflow":"auto"}
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  class: "col-12",
  style: {"padding-right":"100px"}
}
const _hoisted_19 = { class: "midia-app-title-header-table-lg" }
const _hoisted_20 = { class: "midia-app-label-sm" }
const _hoisted_21 = { class: "midia-app-label-sm" }

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import BackButtonInstitucional from '@/components/BackButtonInstitucional.vue'
import InstitutionalDevicesDistributionSection from '@/components/telasInstitucionais/InstitutionalDevicesDistributionSection.vue'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import messages from '@/utils/messages'
import type { QTableProps } from 'quasar'


export default /*@__PURE__*/_defineComponent({
  __name: 'PageInstitutionalDistribution',
  setup(__props) {

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const router = useRouter()
const isUpdatingFromBackend = ref(false)

/* =====================
 * COLUNAS
 * ===================== */
const columns = [
  { name: 'pc',     label: 'Código PC', field: 'pc',     align: 'center' as const },
  { name: 'nome',   label: 'Nome PC',   field: 'nome',   align: 'left'   as const },
  { name: 'status', label: 'Status',    field: 'status', align: 'left'   as const },
  { name: 'motivo', label: 'Motivo',    field: 'motivo', align: 'left'   as const }
]
const visibleColumns = ref(['pc', 'nome', 'status', 'motivo'])
const isInitialLoad = ref(true)

/* =====================
 * ESTADO
 * ===================== */
const distribuicao = ref<any>({
  totalPcs: 0,
  totalSucesso: 0,
  totalPendentes: 0,
  ultimaAtualizacao: null,
  totalPcPages: 0,
  currentPcPage: 0
})

const blockPagination = ref(true)


const allPcs      = ref<any[]>([])
const filteredPcs = ref<any[]>([])
const filterPc    = ref('')
//const blockPagination = ref(true)

const pagination = ref({
  currentPage: 0,
  totalPages: 0,
  quasarPagination: { page: 1, rowsPerPage: 10 }
})


/* =====================
 * FETCH PAGINADO
 * ===================== */
/*const fetchDistribuicao = async (telaId: number, page: number) => {
  pagesUtilStore.showLoading = true
  try {
    const response = await institutionalStore.fetchPcsDistribuicao(telaId, page, 100)

    if (response) {
      // ✅ atualiza totalizadores apenas na primeira página
      if (page === 0) {
        distribuicao.value = {
          totalPcs:          response.totalPcs          ?? 0,
          totalSucesso:      response.totalSucesso      ?? 0,
          totalPendentes:    response.totalPendentes    ?? 0,
          ultimaAtualizacao: response.ultimaAtualizacao ?? null,
          totalPcPages:      response.totalPcPages      ?? 0,
          currentPcPage:     response.currentPcPage     ?? 0
        }
        allPcs.value = [...(response.pcsTela || [])]
      } else {
        // ✅ acumula páginas seguintes
        allPcs.value.push(...(response.pcsTela || []))
        distribuicao.value.currentPcPage = response.currentPcPage ?? page
      }

      filteredPcs.value = [...allPcs.value]
      pagination.value.currentPage = response.currentPcPage ?? page
      pagination.value.totalPages  = response.totalPcPages  ?? 0
    }
  } catch (error) {
    messages.showErrorMsg('Erro ao buscar distribuição.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}*/

const fetchDistribuicao = async (telaId: number, page: number) => {
  pagesUtilStore.showLoading = true

  try {
    // ✅ não pega mais retorno
    await institutionalStore.fetchPcsDistribuicao(telaId, page)

    const dist = institutionalStore.distribuicao

    if (dist && dist.pcsTela) {

      // ✅ agora vem do store
      allPcs.value = [...dist.pcsTela]
      filteredPcs.value = [...allPcs.value]

      distribuicao.value = {
        totalPcs: dist.totalPcs ?? 0,
        totalSucesso: dist.totalSucesso ?? 0,
        totalPendentes: dist.totalPendentes ?? 0,
        ultimaAtualizacao: dist.ultimaAtualizacao ?? null,
        totalPcPages: dist.totalPcPages ?? 0,
        currentPcPage: dist.currentPcPage ?? 0
      }

      pagination.value.currentPage = dist.currentPcPage ?? 0
      pagination.value.totalPages = dist.totalPcPages ?? 0
    }

  } catch (error) {
    messages.showErrorMsg('Erro ao buscar distribuição.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}

/* =====================
 * LIFECYCLE
 * ===================== */
/*onMounted(async () => {
  const id = institutionalStore.institutionalDetail?.id
  if (!id) {
    messages.showErrorMsg('Cadastro não encontrado. Redirecionando...')
    router.push({ name: 'home' })
    return
  }
  await fetchDistribuicao(id, 0)
})*/


onMounted(async () => {
  const id = institutionalStore.institutionalDetail?.id

  if (!id) {
    messages.showErrorMsg('Cadastro não encontrado.')
    router.push({ name: 'home' })
    return
  }

  await fetchDistribuicao(id, 0)
})

/* =====================
 * BUSCA LOCAL
 * ===================== */
const searchPcs = () => {
  if (!filterPc.value) {
    filteredPcs.value = [...allPcs.value]
    return
  }
  const q = filterPc.value.toLowerCase()
  filteredPcs.value = allPcs.value.filter(pc =>
    pc?.pc?.toString().toLowerCase().includes(q) ||
    pc?.nome?.toLowerCase().includes(q)           ||
    pc?.status?.toLowerCase().includes(q)         ||
    pc?.motivo?.toLowerCase().includes(q)
  )
}

/* =====================
 * PAGINAÇÃO
 * ===================== */
/*const updatePagination = async (newPagination: object) => {
  if (newPagination && blockPagination.value) {
    blockPagination.value = false
    return
  }

  const visto = pagination.value.quasarPagination.rowsPerPage * pagination.value.quasarPagination.page
  const total = allPcs.value.length

  if (visto > 0 && total > 0 && visto >= total - 1) {
    const id = institutionalStore.institutionalDetail?.id
    if (id && pagination.value.currentPage < pagination.value.totalPages - 1) {
      await fetchDistribuicao(id, pagination.value.currentPage + 1)
    }
  }
}*/
const updatePagination = async (newPagination: any) => {

  if (newPagination && blockPagination.value) {
    blockPagination.value = false
    return
  }

  const total = filteredPcs.value.length

  const vistos =
    pagination.value.quasarPagination.rowsPerPage *
    pagination.value.quasarPagination.page

  if (vistos > 0 && total > 0 && vistos >= total - 1) {

    const id = institutionalStore.institutionalDetail?.id

    if (
      id &&
      pagination.value.currentPage < pagination.value.totalPages - 1
    ) {
      await fetchDistribuicao(id, pagination.value.currentPage + 1)
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_c_readonly_field = _resolveComponent("c-readonly-field")!
  const _component_c_q_separator = _resolveComponent("c-q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButtonInstitucional),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_c_readonly_field, {
              title: "Cadastro Institucional",
              description: _unref(institutionalStore).institutionalDetail?.nome
            }, null, 8, ["description"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_c_readonly_field, {
              title: "Total",
              description: distribuicao.value.totalPcs ?? 0,
              descriptionColor: "globalBlue006BA7"
            }, null, 8, ["description"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_c_readonly_field, {
              title: "Última atualização",
              description: 
              distribuicao.value.ultimaAtualizacao
                ? new Date(distribuicao.value.ultimaAtualizacao).toLocaleString()
                : ''
            
            }, null, 8, ["description"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_c_readonly_field, {
              title: "Sucesso",
              description: distribuicao.value.totalSucesso ?? 0,
              descriptionColor: "globalGreen17B51C"
            }, null, 8, ["description"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_c_readonly_field, {
              title: "Pendente",
              description: distribuicao.value.totalPendentes ?? 0,
              descriptionColor: "globalOrangeFF6B00"
            }, null, 8, ["description"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(InstitutionalDevicesDistributionSection, {
              pcsPorGrupo: _unref(institutionalStore).institutionalDetail?.pcsPorGrupo,
              pcs: allPcs.value
            }, null, 8, ["pcsPorGrupo", "pcs"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_c_q_separator, { class: "q-my-lg" }),
    _createElementVNode("div", _hoisted_13, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "q-pb-xs" }, [
        _createElementVNode("span", { class: "midia-app-label-lg" }, "Pesquise um Dispositivo")
      ], -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_q_input, {
              modelValue: filterPc.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((filterPc).value = $event)),
                searchPcs
              ],
              color: "globalAppPrimaryColor",
              "bg-color": "globalAppDefaultBackgroundColor",
              outlined: "",
              dense: "",
              placeholder: "Busque um dispositivo",
              "input-class": "midia-app-content-lg",
              onKeyup: _withKeys(searchPcs, ["enter"])
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "search",
                  class: "q-pa-sm",
                  style: {"background":"var(--globalAppSecondaryColor4)","padding":"6px","position":"relative","left":"-11px","border-right":"1px solid var(--globalAppSecondaryColor2)"}
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_q_table, {
          rows: filteredPcs.value,
          "row-key": "pc",
          columns: columns,
          "visible-columns": visibleColumns.value,
          pagination: pagination.value.quasarPagination,
          "onUpdate:pagination": [
            _cache[1] || (_cache[1] = ($event: any) => ((pagination.value.quasarPagination) = $event)),
            updatePagination
          ],
          "rows-per-page-options": [10, 50, 100, 300, 500],
          "no-data-label": "Nenhum registro encontrado!",
          "rows-per-page-label": "Linhas por página:",
          dense: "",
          flat: "",
          separator: "horizontal",
          class: "midia-app-table q-mt-md"
        }, {
          header: _withCtx((props) => [
            _createVNode(_component_q_tr, {
              props: props,
              style: {"background-color":"var(--globalGrayF8F7F7) !important"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                  return (_openBlock(), _createBlock(_component_q_th, {
                    key: col.field,
                    props: props,
                    style: {"border":"0","padding":"2px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(col.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["props"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          body: _withCtx((props) => [
            _createVNode(_component_q_tr, {
              class: "table-body-rows",
              props: props
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_td, {
                  key: "pc",
                  props: props,
                  style: {"padding":"2px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(props.row.pc), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "nome",
                  props: props,
                  style: {"padding":"2px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(props.row.nome), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "status",
                  props: props,
                  style: {"padding":"2px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "midia-app-label-sm",
                      style: _normalizeStyle('Sucesso' === props.row.status
                  ? 'color: var(--globalGreen17B51C)'
                  : 'color: var(--globalBlue28A5FF)')
                    }, _toDisplayString(props.row.status), 5)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "motivo",
                  props: props,
                  style: {"padding":"2px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "midia-app-label-sm",
                      style: _normalizeStyle('Coleta Pendente' === props.row.motivo
                  ? 'color: var(--globalBlue28A5FF)'
                  : 'color: var(--globalGreen17B51C)')
                    }, _toDisplayString(props.row.motivo), 5)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["rows", "visible-columns", "pagination"])
      ])
    ])
  ], 64))
}
}

})